import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Integrations, ApiEndpointRequest, TestConnectionRequest, TestConnectionResult, FormEndpointAssignment, ApiDeliveryLog } from 'src/app/models/integration.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IntegrationService {

  private baseUrl = environment.apiUrl;
  private endpointsUrl = `${this.baseUrl}/integrations/api-endpoints`;

  constructor(private http: HttpClient) {}

  retrieveApiIntegrations(): Observable<Integrations[]> {
    return this.http.get<Integrations[]>(this.endpointsUrl);
  }

  createApiIntegration(body: ApiEndpointRequest): Observable<Integrations> {
    return this.http.post<Integrations>(this.endpointsUrl, body);
  }

  updateApiIntegration(id: number, body: ApiEndpointRequest): Observable<Integrations> {
    return this.http.put<Integrations>(`${this.endpointsUrl}/${id}`, body);
  }

  toggleStatusApiIntegration(id: number, body: ApiEndpointRequest): Observable<Integrations> {
    return this.http.put<Integrations>(`${this.endpointsUrl}/${id}`, body);
  }

  deleteApiIntegration(id: number): Observable<any> {
    return this.http.delete<any>(`${this.endpointsUrl}/${id}`);
  }

  testApiEndpointById(id: number): Observable<TestConnectionResult> {
    return this.http.post<TestConnectionResult>(`${this.endpointsUrl}/${id}/test`, {});
  }

  testApiEndpointFromPayload(payload: TestConnectionRequest): Observable<TestConnectionResult> {
    return this.http.post<TestConnectionResult>(`${this.endpointsUrl}/test-connection`, payload);
  }

  assignEndpointToForm(templateId: number, apiEndpointConfigId: number): Observable<FormEndpointAssignment> {
    return this.http.post<FormEndpointAssignment>(
      `${this.baseUrl}/integrations/forms/${templateId}/endpoints`,
      { apiEndpointConfigId }
    );
  }

  getFormEndpointAssignments(templateId: number): Observable<FormEndpointAssignment[]> {
    return this.http.get<FormEndpointAssignment[]>(
      `${this.baseUrl}/integrations/forms/${templateId}/endpoints`
    );
  }

  unassignEndpointFromForm(templateId: number, assignmentId: number): Observable<any> {
    return this.http.delete<any>(
      `${this.baseUrl}/integrations/forms/${templateId}/endpoints/${assignmentId}`
    );
  }

  getDeliveryLogs(templateId: number, logSheetId?: number): Observable<ApiDeliveryLog[]> {
    const params = logSheetId != null ? `?logSheetId=${logSheetId}` : '';
    return this.http.get<ApiDeliveryLog[]>(
      `${this.baseUrl}/integrations/forms/${templateId}/endpoints/delivery-logs${params}`
    );
  }

  sendTestFailureEmail(templateId: number, endpointId: number): Observable<{ message: string; recipients: string[] }> {
    return this.http.post<{ message: string; recipients: string[] }>(
      `${this.baseUrl}/integrations/forms/${templateId}/endpoints/${endpointId}/send-test-failure-email`,
      {}
    );
  }
}
